import React from "react";
import "./ContactInfo.css";
import mailIcon from "../../../assets/images/mail.png";
import konumIcon from "../../../assets/images/konum.png";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const ContactInfo = () => {
  const WA_TEXT = encodeURIComponent(
    "Merhaba, Lingify ile iletişime geçmek istiyorum."
  );
  const WHATSAPP_LINK = `https://wa.me/905377723370?text=${WA_TEXT}`;

  return (
    <div className="contact-info-wrapper">
      <div className="contact-info">
        {/* Email */}
        <div className="info-item">
          <img src={mailIcon} alt="Email" className="info-icon" />
          <div className="email-info">
            <p className="label">Email:</p>
            <p className="value">info@lingify.co</p>
          </div>
        </div>

        {/* WhatsApp */}
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="info-item info-item--whatsapp"
          aria-label="WhatsApp ile yazın"
          title="WhatsApp ile yazın"
        >
          <span className="wa-badge" aria-hidden="true">
            <FaWhatsapp className="wa-icon" />
          </span>
        </a>

        {/* Adres */}
        <div className="info-item">
          <img src={konumIcon} alt="Adres" className="info-icon" />
          <div className="email-info">
            <p className="label">Adres</p>
            <p className="value">
              İTÜ ARI TEKNOKENT <br />
              Reşitpaşa, Katar Cd İTÜ Arı Teknokent 3 Binası No:4 İç Kapı no{" "}
              <br />
              B204, 34485 Sarıyer/İstanbul
            </p>
          </div>
        </div>
      </div>

      {/* Sosyaller */}
      <div className="contact-socials">
        <p className="social-title">Sosyal medyada bizi takip edebilirsiniz!</p>
        <div className="social-icons">
          <div className="social-item">
            <Link
              to="https://www.facebook.com/profile.php?id=61554485875953"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF className="social-icon" />
            </Link>
          </div>
          <div className="social-item">
            <Link
              to="https://www.instagram.com/lingify.co/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram className="social-icon" />
            </Link>
          </div>
          <div className="social-item">
            <Link
              to="https://x.com/lingify_co"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter className="social-icon" />
            </Link>
          </div>
          <div className="social-item">
            <Link
              to="https://www.linkedin.com/company/lingify/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn className="social-icon" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
